import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import axiosInstance from '../utils/axios-instance';
import moment from 'moment';
import UseChat from '../utils/use-chat';
import UseAuth from '../utils/use-auth';
import Button from '../components/button/Button';
import RemoveHtmlTags from '../utils/remove-html-tags';



const ChatList = () => {
  const { user } = UseAuth()
  const { setCurrentConversation, setConversations, conversations, currentConversation } = UseChat()
  const [isChatListVisible, setIsChatListVisible] = useState(false);
  const [loading, setLoading] = useState(false)
  const [limit,] = useState(10)


  // ------------------------- [ FETCH CONVERSATIONS ] ---------------------------------

  useEffect(() => {
    const findConversations = async () => {
      try {
        const res = await axiosInstance.get(`/chat/conversations?limit=${limit}`)
        setConversations(res.data)
      } catch (error) {
        console.log(error)
      }
    }

    user?.id && findConversations()
  }, [user?.id])



  const AddNewConversations = async () => {
    setLoading(true)
    try {
      const res = await axiosInstance.get(`/chat/conversations?limit=${limit}&offset=${conversations.data.length}`)
      setConversations({ totalCount: res.data.totalCount, data: [...conversations.data, ...res.data.data] })
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }


  return (
    <div className="flex flex-col md:w-[26%] h-full bg-surface border-r border-gray-100">
      <button
        className={`flex flex-row items-center gap-2 bg-white md:hidden px-4 py-3 border-b border-gray-100 ${isChatListVisible ? 'hidden' : ''}`}
        onClick={() => setIsChatListVisible(!isChatListVisible)}
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
        </svg>
        <span className="text-sm font-medium text-lightBlack">Conversations</span>
      </button>

      {/* Chat list */}
      <div className={`flex flex-col h-[100%] max-h-[92%] md:flex ${isChatListVisible ? 'block' : 'hidden'} w-[100%] pt-5`}>
        <div className='px-5'>
          <div className='w-full flex items-center justify-between mb-4'>
            <h2 className="font-display text-lg font-semibold tracking-tight text-lightBlack">Chats History</h2>
            <Button className='!w-auto !text-xs !px-4 !py-2' onClick={() => setCurrentConversation(null)}>+ New</Button>
          </div>
          <div className="relative mb-5">
            <input
              type="text"
              placeholder="Search chats"
              className="w-full py-2.5 pl-10 pr-4 bg-white border border-gray-200 rounded-xl text-sm placeholder-gray-400 focus:outline-none"
            />
            <span className="absolute left-3.5 top-3 text-gray-400">
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M12.9 14.32a8 8 0 111.41-1.41l4.28 4.29a1 1 0 01-1.42 1.42l-4.28-4.29zM8 14a6 6 0 100-12 6 6 0 000 12z" clipRule="evenodd" />
              </svg>
            </span>
          </div>
        </div>
        <div className='overflow-y-auto h-full custom-scrollbar px-3'>
          {conversations?.data?.map((conversation) => {
            const isActive = currentConversation?.id === conversation?.id;
            return (
              <div
                key={conversation?.id}
                className={`w-full flex justify-between items-start gap-2 py-3 px-3 mb-1 rounded-xl cursor-pointer transition-colors ${
                  isActive ? 'bg-white shadow-soft border border-gray-100' : 'hover:bg-white/70'
                }`}
                onClick={() => {
                  setIsChatListVisible(false);
                  setCurrentConversation(conversation)
                }}
              >
                <div className='w-[80%]'>
                  <p className={`w-full text-ellipsis overflow-hidden text-nowrap text-[14px] font-medium ${isActive ? 'text-blue' : 'text-lightBlack'}`}>{RemoveHtmlTags(conversation?.name.replaceAll('"', ""))}</p>
                  <p className="w-full text-ellipsis overflow-hidden text-nowrap text-xs text-gray-500 mt-0.5">{RemoveHtmlTags(conversation?.messages[0]?.message)}</p>
                </div>
                <span className="text-[11px] text-gray-400 mt-0.5">{moment(conversation?.createdAt).format("hh:mm")}</span>
              </div>
            );
          })}

          {conversations?.data.length < conversations?.totalCount ? (
            <div className="px-2 mt-2">
              <Button disabled={loading} isLoading={loading} variant="secondary" onClick={AddNewConversations}>Load More</Button>
            </div>
          ) : null}
        </div>

      </div>
      <div className="flex bg-white w-[100%] py-4 px-5 cursor-pointer border-t border-gray-100 flex-col-reverse md:flex-row justify-between items-center gap-2">
        <div className='flex items-center'>
          <img
            src="/assets/icons/Ellipse 37.png"
            alt="Profile"
            className="w-9 h-9 rounded-full mr-3 ring-2 ring-gray-100"
          />
          <div>
            <p className="text-sm font-medium text-lightBlack">{user?.name}</p>
            <p className="text-xs text-gray-500">@{user?.email.split('@')[0]}</p>
          </div>
        </div>
        <NavLink to={'/user-setting'} className="ml-auto">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 hover:text-lightBlack transition">•••</span>
        </NavLink>
      </div>
    </div>
  );
};

export default ChatList;
